import React from "react";
import './home-page.style.css';

import Home from "../../components/home-banner/home-banner.component";
const HomePage = () => 
(
    <div className="homepage">
    <Home />
    </div>
);

export default HomePage;